import { useMerchant } from "@auth";
import {
  getCustomerPreviewValues,
  normalizeAmountValue,
  replaceTokens,
} from "@utils";
import { Button, Logo } from "@components";

const RequestEmailPreview = ({
  customerName,
  accountCode,
  message,
  completeMessage,
  isPlainText,
  amount = 1234.45,
  invoicesRequested = "Amount due",
  overrideAmountToken = false,
}) => {
  const { merchant } = useMerchant();

  const primaryColour = merchant?.customisationSettings?.colourSet?.primary;
  const buttonTextColour =
    merchant?.customisationSettings?.colourSet?.buttonText;

  const messageText = message || "";

  const normalizedAmount = normalizeAmountValue(amount);

  const previewValues = overrideAmountToken
    ? [
        ...getCustomerPreviewValues().filter((x) => x.token !== "amount_requested"),
        { token: "amount_requested", value: normalizedAmount },
      ]
    : getCustomerPreviewValues();

  const displayMessage =
    completeMessage ||
    (messageText ? replaceTokens(previewValues, messageText) : "");

  return isPlainText ? (
    <div className="bg-white rounded-xl p-4 max-w-lg mx-auto">
      <p className="fs-7 mt-4" style={{ whiteSpace: "pre-wrap" }}>
        {displayMessage}
      </p>
      <p
        className="text-decoration-underline text-primary fs-7"
        style={{ color: primaryColour }}
      >
        https://ontik.io/pay/1avv23y3k
      </p>
    </div>
  ) : (
    <>
      <div className="w-full flex flex-col items-center bg-white">
        <div className="px-6 mb-4 rounded-xl x-10 z-10 flex flex-col items-stretch max-w-sm">
          <div className="text-center">
            <div className="flex p-3 pt-7 justify-center">
              <Logo
                type="center"
                brand={merchant?.organisationId}
                height="96px"
                width="200px"
              />
            </div>
          </div>
          <div className="text-center mt-4">
            <span className="font-bold text-4xl">{invoicesRequested === "Total balance" ? "Settle any invoice" : "Payment Required"}</span>
          </div>
          <div className="text-center mt-5">
            <span className="text-xs">
              {customerName || "John Doe"} ({accountCode || "ACC-CODE"})
            </span>
          </div>
          <div className="px-6 my-8">
            <p className="text-sm" style={{ whiteSpace: "pre-wrap" }}>
              {displayMessage}
            </p>
          </div>
          <div className="flex flex-col bg-zinc-100 p-6 rounded-3xl">
            <div>
              <p className="text-md text-zinc-900 pb-4">{invoicesRequested}</p>
              <p className="text-3xl text-zinc-900 w-full truncate pb-6 font-semibold">
                {normalizedAmount}
              </p>
            </div>
            <div className="flex justify-center w-full">
              <Button
                className="w-full flex items-center justify-center rounded-xl font-medium focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 py-2"
                customColor={{
                  backgroundColor: primaryColour,
                  textColor: buttonTextColour,
                }}
              >
                Review and pay
              </Button>
            </div>
          </div>
          <div className="my-6">
            <div className="justify-center flex items-end">
              <p className="mb-8 text-xs text-zinc-700 font-medium">
                Powered by <strong>Ontik</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col items-center bg-zinc-100 p-10">
          <div className="text-center text-zinc-500 text-[10px] max-w-sm">
            <p className="mt-2">
              This email has been sent by Ontik Technologies Limited
              <br />
              Ontik Technologies Limited | Company# 1437418, London, United
              Kingdom, SW5 9NR
              <br />
              You and your personal information are safe and secure with Ontik.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestEmailPreview;
